// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite20Filled: FC<Favorite20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M18.3 7.485v.022l-.002.036a3.764 3.764 0 0 1-.063.472 5.74 5.74 0 0 1-.384 1.192c-.43.975-1.257 2.232-2.837 3.514a24.905 24.905 0 0 0-3.325 3.226c-.354.417-.61.756-.777.987a9.224 9.224 0 0 0-.224.324l-.008.013-.665 1.071-.686-1.057-.002-.003-.01-.015-.047-.07c-.044-.062-.11-.157-.2-.279-.18-.244-.453-.6-.817-1.028a24.153 24.153 0 0 0-3.264-3.166C3.4 11.449 2.571 10.189 2.144 9.21a5.68 5.68 0 0 1-.381-1.198 3.772 3.772 0 0 1-.06-.475L1.7 7.502V7.48l.8-.004-.8.004v-.004c0-1.407.393-2.46.991-3.226a4.435 4.435 0 0 1 1.957-1.409l.189-.066c.948-.31 1.97-.3 2.916.029C8.852 3.186 9.559 4.056 10 4.837c.441-.781 1.149-1.65 2.247-2.032a4.56 4.56 0 0 1 3.105.036c.618.233 1.365.653 1.957 1.41.598.766.99 1.818.99 3.225v.009Z" />
        </svg>
    );
};

export default Favorite20Filled;
